import React, { useState } from 'react';
import FadeIn from '../components/ui/FadeIn';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', instagram: '', businessType: '', message: ''
  });

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Vielen Dank für deine Anfrage! Ich werde mich zeitnah bei dir melden.');
    setFormData({name: '', email: '', phone: '', instagram: '', businessType: '', message: ''});
  };

  return (
    <div className="pt-32 pb-32 bg-brand-cream min-h-screen">
      <div className="container mx-auto px-6 max-w-7xl">
        
        <div className="bg-white rounded-[4rem] shadow-2xl overflow-hidden border border-black/5">
          <div className="grid lg:grid-cols-5 min-h-[700px]">
            
            <div className="lg:col-span-2 bg-brand-dark text-white p-12 md:p-16 relative overflow-hidden flex flex-col justify-between">
              <div className="absolute top-0 right-0 w-80 h-80 bg-brand-accent/20 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2"></div>
              
              <div className="relative z-10">
                <h2 className="text-5xl font-serif mb-8 leading-tight">Lass uns <br/><span className="italic text-brand-accent">starten.</span></h2>
                <p className="text-white/70 text-lg mb-16 leading-relaxed font-light">
                  Fülle das Formular aus, damit ich mich optimal auf unser erstes kostenloses Strategiegespräch vorbereiten kann.
                </p>

                <div className="space-y-10">
                  <a href="mailto:hallo@glowconsulting.de" className="flex items-center gap-6 group">
                    <div className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-brand-accent group-hover:border-brand-accent group-hover:text-white transition-all duration-500">
                      <SafeIcon name="Mail" className="w-6 h-6" />
                    </div>
                    <div>
                      <p className="text-xs text-brand-accent font-bold uppercase tracking-widest">E-Mail</p>
                      <p className="text-lg font-light mt-1 group-hover:text-brand-accent transition-colors">hallo@glowconsulting.de</p>
                    </div>
                  </a>
                  
                  <a href="#" className="flex items-center gap-6 group">
                    <div className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-brand-accent group-hover:border-brand-accent group-hover:text-white transition-all duration-500">
                      <SafeIcon name="Instagram" className="w-6 h-6" />
                    </div>
                    <div>
                      <p className="text-xs text-brand-accent font-bold uppercase tracking-widest">Instagram</p>
                      <p className="text-lg font-light mt-1 group-hover:text-brand-accent transition-colors">@rukiye.amini</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-3 p-12 md:p-16 lg:p-20 bg-white">
              <FadeIn>
                <div className="mb-12">
                  <h3 className="text-3xl font-serif text-brand-dark mb-3">Deine Anfrage</h3>
                  <p className="text-brand-text font-light text-lg">100% kostenlos und unverbindlich.</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-8">
                  <div className="grid md:grid-cols-2 gap-8">
                    <div className="space-y-2">
                      <label className="text-xs font-bold uppercase tracking-widest text-brand-dark">Name *</label>
                      <input required type="text" name="name" value={formData.name} onChange={handleChange} 
                        className="w-full px-0 py-4 bg-transparent border-b-2 border-brand-dark/10 focus:border-brand-accent transition-colors duration-300 outline-none text-brand-dark placeholder:text-brand-dark/30 font-light text-lg rounded-none" 
                        placeholder="Dein Vor- und Nachname"
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="text-xs font-bold uppercase tracking-widest text-brand-dark">E-Mail *</label>
                      <input required type="email" name="email" value={formData.email} onChange={handleChange} 
                        className="w-full px-0 py-4 bg-transparent border-b-2 border-brand-dark/10 focus:border-brand-accent transition-colors duration-300 outline-none text-brand-dark placeholder:text-brand-dark/30 font-light text-lg rounded-none" 
                        placeholder="deine@email.de"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-8">
                    <div className="space-y-2">
                      <label className="text-xs font-bold uppercase tracking-widest text-brand-dark">Instagram</label>
                      <input type="text" name="instagram" value={formData.instagram} onChange={handleChange} 
                        className="w-full px-0 py-4 bg-transparent border-b-2 border-brand-dark/10 focus:border-brand-accent transition-colors duration-300 outline-none text-brand-dark placeholder:text-brand-dark/30 font-light text-lg rounded-none" 
                        placeholder="@deinprofil"
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="text-xs font-bold uppercase tracking-widest text-brand-dark">Business *</label>
                      <select required name="businessType" value={formData.businessType} onChange={handleChange} 
                        className="w-full px-0 py-4 bg-transparent border-b-2 border-brand-dark/10 focus:border-brand-accent transition-colors duration-300 outline-none text-brand-dark font-light text-lg cursor-pointer rounded-none appearance-none"
                      >
                        <option value="" disabled>Bitte wählen...</option>
                        <option value="kosmetikstudio">Kosmetikstudio / Salon</option>
                        <option value="influencer">Influencerin</option>
                        <option value="dienstleister">Dienstleisterin</option>
                        <option value="andere">Andere</option>
                      </select>
                    </div>
                  </div>

                  <div className="space-y-2 pt-4">
                    <label className="text-xs font-bold uppercase tracking-widest text-brand-dark">Wo stehst du gerade?</label>
                    <textarea rows="3" name="message" value={formData.message} onChange={handleChange} 
                      className="w-full px-0 py-4 bg-transparent border-b-2 border-brand-dark/10 focus:border-brand-accent transition-colors duration-300 outline-none text-brand-dark placeholder:text-brand-dark/30 font-light text-lg resize-none rounded-none"
                      placeholder="Erzähl mir kurz von deiner aktuellen Herausforderung..."
                    ></textarea>
                  </div>

                  <div className="pt-6">
                    <Button type="submit" variant="primary" className="w-full md:w-auto !px-12 !py-5 text-base">
                      Jetzt absenden
                    </Button>
                  </div>
                  
                  <p className="text-xs text-brand-text/50 mt-6 font-light">
                    Mit dem Absenden erklärst du dich mit unseren Datenschutzbestimmungen einverstanden.
                  </p>
                </form>
              </FadeIn>
            </div>
            
          </div>
        </div>

      </div>
    </div>
  );
};

export default Contact;